import styled from "styled-components";
import { dimensions } from "../../../constants";

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 10px;
`;

export const Action = styled.div`
  display: flex;
  flex: 1;
`;

export const ActionInfo = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  background-color: #f0f0f0;
  color: #5f5f5f;
  border-radius: 3px;
  margin: 0 0 10px 40px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid ${({ borderColor }) => borderColor};

  @media (max-width: ${dimensions.mobile}px) {
    div {
      display: flex;
      flex-direction: column;

      span {
        padding-left: 10px;
      }

      :last-child {
        flex-direction: row;
        align-items: center;
      }
    }
  }
`;

export const CreationDate = styled.span`
  padding-right: 10px;
  font-size: 12px;
  font-weight: 300;
  line-height: 27px;
`;

export const Origin = styled.span`
  font-size: 12px;
  font-style: italic;
  font-weight: 27px;
`;

export const Id = styled.span`
  line-height: 27px;
  font-weight: 700;
  font-size: 16px;
  padding: 0 10px;
`;

export const Body = styled.div`
  padding: 10px;
  word-break: break-all;
`;

export const Name = styled.span`
  padding: 0 10px;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-y: hidden;
  line-height: 27px;
`;

export const Thumbnail = styled.img`
  width: 40px;
  height: 40px;
`;
